import { IconProps } from '@/root/shared-types/ui/ui-types'
import React, { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const PenIcon: FC<IconProps> = ({ width = 20, height = 20, ...rest }) => (
  <Icon type="Pen" width={width} height={height} alt="Pen" {...rest} />
)
